import { useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';

import { budgetDataService } from 'services/budget.service';

import { useUsersContext } from 'contexts/UsersContext';

import { useFetch } from 'hooks';

import { Data } from 'pages/Catalogue/components/Budget/components/Data';
import { Sent } from 'pages/Catalogue/components/Budget/components/Sent';

import { Headline } from 'components/Headline';
import { TabType, Tabs } from 'components/Tabs';

import * as S from './Manage.styles';

type ManageProps = {
  title: string;
  tabs: TabType[];
  isNew?: boolean;
};

const defaultProps: Partial<ManageProps> = {};

export function Manage(props: ManageProps): React.ReactElement {
  const { title, tabs } = { ...defaultProps, ...props };
  const { onSubmit, form } = useUsersContext();

  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const season = searchParams.get('season') ?? undefined;
  const seasonLine = searchParams.get('seasonLine') ?? undefined;
  const genderCode = searchParams.get('genderCode') ?? undefined;
  const zone = searchParams.get('zone') ?? undefined;
  const type = searchParams.get('type') ?? undefined;

  const params =
    season !== undefined &&
    seasonLine !== undefined &&
    genderCode !== undefined &&
    zone !== undefined &&
    type !== undefined
      ? { season, seasonLine, genderCode, zone, type }
      : undefined;

  const { data } = useFetch(
    id && title !== 'Users' ? () => budgetDataService.getById(id, params) : undefined,
    [id, season, seasonLine, genderCode, zone, type]
  );

  const updatedTabs = tabs.map((tab) => {
    if (data) {
      if (tab.title === 'Data') {
        return { ...tab, content: <Data data={data} /> };
      }
      return { ...tab, content: <Sent /> };
    }
    return tab;
  });

  useEffect(
    () => () => {
      if (form?.formState?.isDirty && title !== 'Users') onSubmit();
    },
    []
  );

  return (
    <S.Container>
      <S.Header>
        <Headline fontWeight="bold" fontFamily="LFT Zeno Condensed" scale="xl" color="black">
          {title}
        </Headline>
        {/* commented, not sure if it's used somewhere */}
        {/* {!isNew && (
          <S.ButtonsContainer>
            <Button
              onClick={async () => {
                await onSubmit();
                if (Object.keys(form.formState.errors).length === 0) {
                  navigate(routes.users);
                }
              }}
              disabled={id === undefined}
              motive="accept"
            >
              DONE
            </Button>
          </S.ButtonsContainer>
        )} */}
      </S.Header>

      <S.Tabs>
        <Tabs saveUser={onSubmit} tabs={updatedTabs} />
      </S.Tabs>
    </S.Container>
  );
}
